function getOutboundTransmissions(state) {
	return state.outboundTransmissions;
}

function getInboundTransmissions(state) {
	return state.inboundTransmissions;
}

export default { getOutboundTransmissions, getInboundTransmissions };